import { Toggle } from '@/shared/components/ui/Toggle';

interface SignalToggleProps {
  isActive: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

export const SignalToggle = ({
  isActive,
  onToggle,
  disabled,
}: SignalToggleProps) => {
  return (
    <Toggle
      checked={isActive}
      onChange={() => onToggle()}
      disabled={disabled}
      onClick={(e) => e.stopPropagation()}
    />
  );
};
